module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAABKUlEQVR42u3XR4rEQAwF0L7/Fbxx9sY5HcQ3cI7gSK9HDEwhGHpjm5YX0gkeVaUv1ev9sHoxiEEMYhCDGPQVUJZliqJ4njeO4yNAsixLv2Wa5jAM9KA4jqW/Mgyj73ti0LIstm0Lk67rXdcRP2owOY5zu+lSl63rCu9amDRNa5qGuO3B5Pu+MKmqWtc1cQ5t2xYEgTBBHFRVRRyMYIqiSJggFMqyJE7qfd9xFsA55XlOPDrAlCQJPqcTpptn2XEcaZoKk2VZDPr8jIiv7P+jLoqCsu3DMMQayraHsMbBCGFNGYxwNnicgebiOLs6XF3XxcO1bdsHrR/XNedB8zzjBQ2WRuIFDY9SWKvpV1ix5EMW3/vxOP8NAhP01zRN/FFkEIMYxCAGMQjXD2DLfkL/O09EAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/right_arrow_tap.png
// module id = 1908
// module chunks = 0